module.exports = __webpack_public_path__ + "img/oregon-white-oak.f9767d97.jpg";